module.exports = __webpack_public_path__ + "img/public/SiteIcons/check_theme.svg?5599f965";